module.exports = __webpack_public_path__ + "play-24.30ceddd958fefc528ac970da3b3cccfe.svg";